class Anime {
    constructor(id, name, status) {
        this.id = id;
        this.name = name;
        this.status = status;
    }
}

class AnimeSong {
    constructor(rawName, cleanedName, anime, type) {
      this.rawName = rawName;
      this.cleanedName = cleanedName;
      this.anime = anime;
      // Either 'opening' or 'ending'.
      this.type = type;
    }
}

class QuizQuestion {
    constructor(animeSong, youtubeLink, choices) {
        this.animeSong = animeSong;
        this.youtubeLink = youtubeLink;
        this.choices = choices;
    }
}

export {
    Anime,
    AnimeSong,
    QuizQuestion
}